module.exports = {
  people: {
    select_type: 10,
    select_range: 10,
    select_default: 1
  },
  people_option: []
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/people.js